export const quantumPageNL = {
  "seo": {
    "title": "Soevereine LLM's & Quantum-AI | pAIoneer Labs GmbH",
    "description": "Ons doel vanuit Duitsland: onder Veridion ('AI ontwikkelt AI verder') eigen compacte taalmodellen en Quantum Transformers ontwikkelen die straks concurreren met grote modellen uit de VS en China."
  },
  "hero": {
    "kicker": "Made in Germany · AI ontwikkelt AI",
    "title": "Soevereine LLM's & Quantum-AI",
    "claim": "Ons doel vanuit Duitsland: eigen taalmodellen en Quantum Transformers ontwikkelen die straks de concurrentie aangaan met de grote modellen uit de VS en China.",
    "subtitle": "In echte bedrijfsprojecten zijn de bestaande Europese benaderingen — de Duitse modellen van Aleph Alpha (zoals Kolibri), de Franse modellen rond Mistral, EuroLLM en met name het Zwitserse model Apertus — getest op reële praktijkproblemen. Geen van deze modellen voldoet aan de eisen in bedrijven. Daarom zet onze AI onder [Veridion](veridion) (“AI ontwikkelt AI verder”) de volgende stap: zij onderzoekt en ontwikkelt de weg naar compacte taalmodellen Made in Germany die veel sterker zullen zijn dan de Franse modellen, en bouwt als tweede speerpunt aan eigen Quantum Transformers.",
    "cta": "Gesprek plannen"
  },
  "pillars": {
    "title": "Waaraan onze AI werkt",
    "subtitle": "Twee onderzoeksgebieden waarin onze digitale medewerkers nieuwe architecturen ontwerpen, in simulatie toetsen en stap voor stap opbouwen.",
    "items": [
      {
        "title": "Wat een taalmodel in de praktijk moet presteren",
        "description": "In dagelijks gebruik tellen meerstaps logisch redeneren, betrouwbaar tool-gebruik over lange werkstromen, schone softwareontwikkeling en foutloze kantoorprocessen. Daaraan meten wij elke architectuur vanaf het begin."
      },
      {
        "title": "Compacte modellen voor eigen infrastructuur",
        "description": "In plaats van steeds grotere datacenters zal ons doel zijn om hoge denkracht te bundelen in een compact model dat bedrijven straks volledig lokaal op eigen hardware kunnen draaien."
      },
      {
        "title": "Quantum Transformers & Quantum-AI",
        "description": "In het tweede zwaartepunt onderzoeken wij hoe transformer-architecturen te verbinden zijn met geparametriseerde kwantumcircuits en tensor-netwerken om nieuwe modelklassen te ontsluiten."
      },
      {
        "title": "Eigen Quantum IDE & echte kwantumprocessoren",
        "description": "In onze zelfontwikkelde Quantum IDE ontwerpen, simuleren en testen onze AI-medewerkers nieuwe kwantumcircuits tegen klassieke baselines voordat ze op echte kwantumhardware draaien."
      }
    ]
  },
  "gate": {
    "title": "Van onderzoeksstand naar blauwdruk",
    "subtitle": "Elke ontwikkelstap steunt op getoetste literatuur, ons bedrijfsgeheugen en meetbare vergelijkingen.",
    "stages": [
      {
        "step": "Stap 01",
        "title": "Literatuuranalyse & bedrijfsgeheugen",
        "description": "Onze AI-medewerkers analyseren doorlopend de nieuwste wetenschappelijke publicaties over taalmodel- en kwantumarchitecturen en slaan alle geverifieerde bevindingen op in onze kennisgraaf."
      },
      {
        "step": "Stap 02",
        "title": "Trainingsroutekaart & circuitsimulatie",
        "description": "Samen met Productontwikkeling ontstaat hieruit het gedetailleerde trainingsplan voor ons toekomstige taalmodel, terwijl parallel nieuwe kwantumcircuits in de Quantum IDE worden beproefd."
      },
      {
        "step": "Stap 03",
        "title": "Wetenschappelijke toetsing in het IDD-proces",
        "description": "Menselijke fysici en AI-onderzoekers toetsen elke hypothese, elke meting en elk ontwerp via [Intent-Driven Development](idd) (IDD) als human-in-the-loop en geven de volgende stap vrij."
      }
    ]
  },
  "stack": {
    "title": "Mens en AI in één onderzoekseenheid",
    "subtitle": "Onderzoek, productontwikkeling en wetenschappelijk toezicht grijpen in vaste cycli in elkaar.",
    "items": [
      {
        "title": "Digitale onderzoekers dag en nacht",
        "description": "Gespecialiseerde AI-medewerkers verzorgen literatuurstudie, wiskundige afleidingen, circuitontwerp en evaluatie vierentwintig uur per dag."
      },
      {
        "title": "Fysici in de Human-in-the-Loop",
        "description": "Menselijke wetenschappers bepalen de onderzoeksrichting, toetsen aannames en beslissen over vrijgaven, hardware-runs en publicaties."
      },
      {
        "title": "Verweven met Productontwikkeling",
        "description": "Afgestemd met onze productontwikkeling vloeien bewezen onderzoeksresultaten rechtstreeks naar onze tools en toekomstige bedrijfsoplossingen."
      },
      {
        "title": "Herleidbaar tot de bron",
        "description": "Elke architectuurbeslissing, elke verworpen variant en elk meetresultaat blijft blijvend gedocumenteerd en voor mens en AI controleerbaar."
      }
    ]
  },
  "cta": {
    "title": "Uitwisseling over onderzoek",
    "subtitle": "Wilt u van gedachten wisselen over ons onderzoek naar soevereine taalmodellen en Quantum Transformers? Schrijf ons.",
    "button": "Bericht sturen"
  }
};
